import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './Settings.css';

const Settings = () => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      setUser(user);
      fetchUserName(user.id);
    }
  };

  const fetchUserName = async (userId) => {
    try {
      const { data, error } = await supabase
        .from('users')
        .select('name')
        .eq('id', userId)
        .single();

      if (error) throw error;
      
      if (data && data.name) {
        setUserName(data.name);
      }
    } catch (error) {
      console.error('Error fetching user name:', error);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-container">
        <h1>Settings</h1>
        <p className="settings-subtitle">Manage your account settings</p>

        <div className="settings-content">
          {/* Account Section */}
          <div className="settings-section">
            <h2 className="section-header">Account</h2>
            
            <div className="settings-card">
              <div className="settings-item">
                <div className="settings-item-info">
                  <label>Name</label>
                  <p>{userName || 'Not set'}</p>
                </div>
              </div>

              <div className="settings-item">
                <div className="settings-item-info">
                  <label>Email</label>
                  <p>{user?.email}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Security Section */}
          <div className="settings-section">
            <h2 className="section-header">Security</h2>
            
            <div className="settings-card">
              <div className="settings-item">
                <div className="settings-item-info">
                  <label>Logout</label>
                  <p className="settings-description">Sign out of your account</p>
                </div>
                <button 
                  onClick={handleLogout} 
                  disabled={loading}
                  className="logout-button"
                >
                  {loading ? 'Logging out...' : 'Logout'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;

